import { IPProjectLoader, IPProjectLoaderRouteParams, ProjectModel } from "@xlabmedical/implant-planner";
import { usePatientsStore } from "@/stores/PatientsStore";
import { PatientListModel } from "@/models/PatientListModel";

export class IPProjectLoaderRg extends IPProjectLoader {
    private patientsStore = usePatientsStore();
    async getStlFile(patientName: string, filename: string): Promise<Int8Array | null> {
        return (await this.patientsStore.getStlFile(patientName, filename)) ?? null;
    }

    async getProjectInfo(routeParams: IPProjectLoaderRouteParams): Promise<{
        project: ProjectModel;
        patientInfo: PatientListModel;
        projectFullName: string;
    } | null> {
        const { projectHash, fileHash } = routeParams;
        if (!projectHash) {
            console.warn("projectHash is not defined");
            return null;
        }

        if (!fileHash) {
            console.warn("fileHash is not defined");
            return null;
        }

        const project = await this.patientsStore.getProjectByUUID(projectHash);
        if (!project) return null;
        const patientInfo = await this.patientsStore.getPatientInfoByUUID(projectHash);
        if (!patientInfo) return null;

        const projectFileTest = this.patientsStore.getProjectFileByUUID(project, fileHash);

        const firstName = project.patientData?.firstName ?? patientInfo.firstName ?? patientInfo.extra?.firstName ?? "";

        const lastName = project.patientData?.lastName ?? patientInfo.lastName ?? patientInfo.extra?.lastName ?? "";

        const patientFullName = `${firstName} ${lastName}`.trim();
        const projectFullName = `${patientFullName} // ${projectFileTest?.name}`;

        project.projectFilename = projectFileTest?.name || "";

        return {
            project,
            patientInfo,
            projectFullName,
        };
    }
}
